module.exports = __webpack_public_path__ + "public/images/animals.9191f46851fef2b7fb865abd44b4e7ad.png";